import React from 'react'
import { Link, NavLink } from 'react-router-dom';
import "./header.css"
import { BUSINESS, LEGAL_ROUTES } from '../../config/business';

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/bike_catalog", label: "E-Cycles" },
  { to: "/Part_catalog", label: "Parts" },
  { to: "/service", label: "Service" },
  { to: "/finance", label: "Easy EMI" },
  { to: "/storelocator", label: "Locate Stores" },
  { to: "/bloglist", label: "Blog" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact Us" },
];

export default function Header() {
  return (
    <header className="site-header">
      <div className="header-topbar">
        <div className="header-topbar-inner">
          <span>All prices in {BUSINESS.currencyLabel}</span>
          <span className="header-topbar-sep">·</span>
          <span>Delivery in {BUSINESS.serviceArea}</span>
          <a
            className="header-topbar-phone"
            href={`tel:+${BUSINESS.phoneRaw}`}
          >
            {BUSINESS.phone}
          </a>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg" id="header">
        <div className="container-fluid header-inner">
          <Link to="/" className="header-brand">
            <img src="/logo.png" alt={`${BUSINESS.brand} logo`} />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-lg-center">
              {NAV.map((item) => (
                <li className="nav-item" key={item.to}>
                  <NavLink
                    className={({ isActive }) =>
                      "nav-link" + (isActive ? " is-active" : "")
                    }
                    to={item.to}
                    end={item.end}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}

              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle header-dropdown-btn"
                  id="policiesDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  type="button"
                >
                  Policies
                </button>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="policiesDropdown"
                >
                  {LEGAL_ROUTES.map((r) => (
                    <li key={r.path}>
                      <Link className="dropdown-item" to={r.path}>
                        {r.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>

              <li className="nav-item">
                <a
                  className="header-cta"
                  href={`https://wa.me/${BUSINESS.whatsapp}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Enquire
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}
